!function(i) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
}(function(i) {
  "use strict";
  var e = window.Slick || {};
  (e = function() {
      var e = 0;
      return function(t, o) {
          var s, n = this;
          n.defaults = {
              accessibility: !0,
              adaptiveHeight: !1,
              appendArrows: i(t),
              appendDots: i(t),
              arrows: !0,
              asNavFor: null,
              prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
              nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
              autoplay: !1,
              autoplaySpeed: 3e3,
              centerMode: !1,
              centerPadding: "50px",
              cssEase: "ease",
              customPaging: function(i, e) {
                  return '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' + (e + 1) + "</button>"
              },
              dots: !1,
              dotsClass: "slick-dots",
              draggable: !0,
              easing: "linear",
              edgeFriction: .35,
              fade: !1,
              focusOnSelect: !1,
              infinite: !0,
              initialSlide: 0,
              lazyLoad: "ondemand",
              mobileFirst: !1,
              pauseOnHover: !1,
              pauseOnDotsHover: !1,
              respondTo: "window",
              responsive: null,
              rows: 1,
              rtl: !1,
              slide: "",
              slidesPerRow: 1,
              slidesToShow: 1,
              slidesToScroll: 1,
              speed: 500,
              swipe: !0,
              swipeToSlide: !1,
              touchMove: !0,
              touchThreshold: 5,
              useCSS: !0,
              useTransform: !1,
              variableWidth: !1,
              vertical: !1,
              verticalSwiping: !1,
              waitForAnimate: !0,
              zIndex: 1e3
          },
          n.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1
          },
          i.extend(n, n.initials),
          n.activeBreakpoint = null,
          n.animType = null,
          n.animProp = null,
          n.breakpoints = [],
          n.breakpointSettings = [],
          n.cssTransitions = !1,
          n.hidden = "hidden",
          n.paused = !1,
          n.positionProp = null,
          n.respondTo = null,
          n.rowCount = 1,
          n.shouldClick = !0,
          n.$slider = i(t),
          n.$slidesCache = null,
          n.transformType = null,
          n.transitionType = null,
          n.visibilityChange = "visibilitychange",
          n.windowWidth = 0,
          n.windowTimer = null,
          s = i(t).data("slick") || {},
          n.options = i.extend({}, n.defaults, s, o),
          n.currentSlide = n.options.initialSlide,
          n.originalSettings = n.options,
          void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
          n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
          n.visibilityChange = "webkitvisibilitychange"),
          n.autoPlay = i.proxy(n.autoPlay, n),
          n.autoPlayClear = i.proxy(n.autoPlayClear, n),
          n.changeSlide = i.proxy(n.changeSlide, n),
          n.clickHandler = i.proxy(n.clickHandler, n),
          n.selectHandler = i.proxy(n.selectHandler, n),
          n.setPosition = i.proxy(n.setPosition, n),
          n.swipeHandler = i.proxy(n.swipeHandler, n),
          n.dragHandler = i.proxy(n.dragHandler, n),
          n.keyHandler = i.proxy(n.keyHandler, n),
          n.autoPlayIterator = i.proxy(n.autoPlayIterator, n),
          n.instanceUid = e++,
          n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
          n.registerBreakpoints(),
          n.init(!0),
          n.checkResponsive(!0)
      }
  }()).prototype.addSlide = e.prototype.slickAdd = function(e, t, o) {
      var s = this;
      if ("boolean" == typeof t)
          o = t,
          t = null;
      else if (t < 0 || t >= s.slideCount)
          return !1;
      s.unload(),
      "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack),
      s.$slides = s.$slideTrack.children(this.options.slide),
      s.$slideTrack.children(this.options.slide).detach(),
      s.$slideTrack.append(s.$slides),
      s.$slides.each(function(e, t) {
          i(t).attr("data-slick-index", e)
      }),
      s.$slidesCache = s.$slides,
      s.reinit()
  }
  ,
  e.prototype.animateHeight = function() {
      var i = this;
      if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.animate({
              height: e
          }, i.options.speed)
      }
  }
  ,
  e.prototype.animateSlide = function(e, t) {
      var o = {}
        , s = this;
      s.animateHeight(),
      !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
      !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
          left: e
      }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({
          top: e
      }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
      i({
          animStart: s.currentLeft
      }).animate({
          animStart: e
      }, {
          duration: s.options.speed,
          easing: s.options.easing,
          step: function(i) {
              i = Math.ceil(i),
              !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)",
              s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)",
              s.$slideTrack.css(o))
          },
          complete: function() {
              t && t.call()
          }
      })) : (s.applyTransition(),
      e = Math.ceil(e),
      !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)",
      s.$slideTrack.css(o),
      t && setTimeout(function() {
          s.disableTransition(),
          t.call()
      }, s.options.speed))
  }
  ,
  e.prototype.asNavFor = function(e) {
      var t = this.options.asNavFor;
      t && null !== t && (t = i(t).not(this.$slider)),
      null !== t && "object" == typeof t && t.each(function() {
          var t = i(this).slick("getSlick");
          t.unslicked || t.slideHandler(e, !0)
      })
  }
  ,
  e.prototype.applyTransition = function(i) {
      var e = this
        , t = {};
      !1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase,
      !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
  }
  ,
  e.prototype.autoPlay = function() {
      var i = this;
      i.autoPlayTimer && clearInterval(i.autoPlayTimer),
      i.slideCount > i.options.slidesToShow && !0 !== i.paused && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
  }
  ,
  e.prototype.autoPlayClear = function() {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer)
  }
  ,
  e.prototype.autoPlayIterator = function() {
      var i = this;
      !1 === i.options.infinite ? 1 === i.direction ? (i.currentSlide + 1 === i.slideCount - 1 && (i.direction = 0),
      i.slideHandler(i.currentSlide + i.options.slidesToScroll)) : (i.currentSlide - 1 == 0 && (i.direction = 1),
      i.slideHandler(i.currentSlide - i.options.slidesToScroll)) : i.slideHandler(i.currentSlide + i.options.slidesToScroll)
  }
  ,
  e.prototype.buildArrows = function() {
      var e = this;
      !0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"),
      e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"),
      e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
      e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
      e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
      e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
      !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
          "aria-disabled": "true",
          tabindex: "-1"
      }))
  }
  ,
  e.prototype.buildDots = function() {
      var e, t, o = this;
      if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
          for (t = '<ul class="' + o.options.dotsClass + '">',
          e = 0; e <= o.getDotCount(); e += 1)
              t += "<li>" + o.options.customPaging.call(this, o, e) + "</li>";
          t += "</ul>",
          o.$dots = i(t).appendTo(o.options.appendDots),
          o.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
      }
  }
  ,
  e.prototype.buildOut = function() {
      var e = this;
      e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
      e.slideCount = e.$slides.length,
      e.$slides.each(function(e, t) {
          i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "")
      }),
      e.$slider.addClass("slick-slider"),
      e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(),
      e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
      e.$slideTrack.css("opacity", 0),
      !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1),
      i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
      e.setupInfinite(),
      e.buildArrows(),
      e.buildDots(),
      e.updateDots(),
      e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
      !0 === e.options.draggable && e.$list.addClass("draggable")
  }
  ,
  e.prototype.buildRows = function() {
      var i, e, t, o, s, n, l, r = this;
      if (o = document.createDocumentFragment(),
      n = r.$slider.children(),
      r.options.rows > 1) {
          for (l = r.options.slidesPerRow * r.options.rows,
          s = Math.ceil(n.length / l),
          i = 0; i < s; i++) {
              var a = document.createElement("div");
              for (e = 0; e < r.options.rows; e++) {
                  var d = document.createElement("div");
                  for (t = 0; t < r.options.slidesPerRow; t++) {
                      var c = i * l + (e * r.options.slidesPerRow + t);
                      n.get(c) && d.appendChild(n.get(c))
                  }
                  a.appendChild(d)
              }
              o.appendChild(a)
          }
          r.$slider.html(o),
          r.$slider.children().children().children().css({
              width: 100 / r.options.slidesPerRow + "%",
              display: "inline-block"
          })
      }
  }
  ,
  e.prototype.checkResponsive = function(e, t) {
      var o, s, n, l = this, r = !1, a = l.$slider.width(), d = window.innerWidth || i(window).width();
      if ("window" === l.respondTo ? n = d : "slider" === l.respondTo ? n = a : "min" === l.respondTo && (n = Math.min(d, a)),
      l.options.responsive && l.options.responsive.length && null !== l.options.responsive) {
          for (o in s = null,
          l.breakpoints)
              l.breakpoints.hasOwnProperty(o) && (!1 === l.originalSettings.mobileFirst ? n < l.breakpoints[o] && (s = l.breakpoints[o]) : n > l.breakpoints[o] && (s = l.breakpoints[o]));
          null !== s ? null !== l.activeBreakpoint ? (s !== l.activeBreakpoint || t) && (l.activeBreakpoint = s,
          "unslick" === l.breakpointSettings[s] ? l.unslick(s) : (l.options = i.extend({}, l.originalSettings, l.breakpointSettings[s]),
          !0 === e && (l.currentSlide = l.options.initialSlide),
          l.refresh(e)),
          r = s) : (l.activeBreakpoint = s,
          "unslick" === l.breakpointSettings[s] ? l.unslick(s) : (l.options = i.extend({}, l.originalSettings, l.breakpointSettings[s]),
          !0 === e && (l.currentSlide = l.options.initialSlide),
          l.refresh(e)),
          r = s) : null !== l.activeBreakpoint && (l.activeBreakpoint = null,
          l.options = l.originalSettings,
          !0 === e && (l.currentSlide = l.options.initialSlide),
          l.refresh(e),
          r = s),
          e || !1 === r || l.$slider.trigger("breakpoint", [l, r])
      }
  }
  ,
  e.prototype.changeSlide = function(e, t) {
      var o, s, n = this, l = i(e.target);
      switch (l.is("a") && e.preventDefault(),
      l.is("li") || (l = l.closest("li")),
      o = n.slideCount % n.options.slidesToScroll != 0 ? 0 : (n.slideCount - n.currentSlide) % n.options.slidesToScroll,
      e.data.message) {
      case "previous":
          s = 0 === o ? n.options.slidesToScroll : n.options.slidesToShow - o,
          n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide - s, !1, t);
          break;
      case "next":
          s = 0 === o ? n.options.slidesToScroll : o,
          n.slideCount > n.options.slidesToShow && n.slideHandler(n.currentSlide + s, !1, t);
          break;
      case "index":
          var r = 0 === e.data.index ? 0 : e.data.index || l.index() * n.options.slidesToScroll;
          n.slideHandler(n.checkNavigable(r), !1, t),
          l.children().trigger("focus");
          break;
      default:
          return
      }
  }
  ,
  e.prototype.checkNavigable = function(i) {
      var e, t;
      if (t = 0,
      i > (e = this.getNavigableIndexes())[e.length - 1])
          i = e[e.length - 1];
      else
          for (var o in e) {
              if (i < e[o]) {
                  i = t;
                  break
              }
              t = e[o]
          }
      return i
  }
  ,
  e.prototype.cleanUpEvents = function() {
      var e = this;
      e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide),
      !0 === e.options.pauseOnDotsHover && !0 === e.options.autoplay && i("li", e.$dots).off("mouseenter.slick", i.proxy(e.setPaused, e, !0)).off("mouseleave.slick", i.proxy(e.setPaused, e, !1))),
      !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
      e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
      e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
      e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
      e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
      e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
      e.$list.off("click.slick", e.clickHandler),
      i(document).off(e.visibilityChange, e.visibility),
      e.$list.off("mouseenter.slick", i.proxy(e.setPaused, e, !0)),
      e.$list.off("mouseleave.slick", i.proxy(e.setPaused, e, !1)),
      !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
      !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler),
      i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
      i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
      i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
      i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
      i(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
  }
  ,
  e.prototype.cleanUpRows = function() {
      var i, e = this;
      e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"),
      e.$slider.html(i))
  }
  ,
  e.prototype.clickHandler = function(i) {
      !1 === this.shouldClick && (i.stopImmediatePropagation(),
      i.stopPropagation(),
      i.preventDefault())
  }
  ,
  e.prototype.destroy = function(e) {
      var t = this;
      t.autoPlayClear(),
      t.touchObject = {},
      t.cleanUpEvents(),
      i(".slick-cloned", t.$slider).detach(),
      t.$dots && t.$dots.remove(),
      t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
      t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
      t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
      t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
      t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
          i(this).attr("style", i(this).data("originalStyling"))
      }),
      t.$slideTrack.children(this.options.slide).detach(),
      t.$slideTrack.detach(),
      t.$list.detach(),
      t.$slider.append(t.$slides)),
      t.cleanUpRows(),
      t.$slider.removeClass("slick-slider"),
      t.$slider.removeClass("slick-initialized"),
      t.unslicked = !0,
      e || t.$slider.trigger("destroy", [t])
  }
  ,
  e.prototype.disableTransition = function(i) {
      var e = this
        , t = {};
      t[e.transitionType] = "",
      !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t)
  }
  ,
  e.prototype.fadeSlide = function(i, e) {
      var t = this;
      !1 === t.cssTransitions ? (t.$slides.eq(i).css({
          zIndex: t.options.zIndex
      }),
      t.$slides.eq(i).animate({
          opacity: 1
      }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i),
      t.$slides.eq(i).css({
          opacity: 1,
          zIndex: t.options.zIndex
      }),
      e && setTimeout(function() {
          t.disableTransition(i),
          e.call()
      }, t.options.speed))
  }
  ,
  e.prototype.fadeSlideOut = function(i) {
      var e = this;
      !1 === e.cssTransitions ? e.$slides.eq(i).animate({
          opacity: 0,
          zIndex: e.options.zIndex - 2
      }, e.options.speed, e.options.easing) : (e.applyTransition(i),
      e.$slides.eq(i).css({
          opacity: 0,
          zIndex: e.options.zIndex - 2
      }))
  }
  ,
  e.prototype.filterSlides = e.prototype.slickFilter = function(i) {
      var e = this;
      null !== i && (e.$slidesCache = e.$slides,
      e.unload(),
      e.$slideTrack.children(this.options.slide).detach(),
      e.$slidesCache.filter(i).appendTo(e.$slideTrack),
      e.reinit())
  }
  ,
  e.prototype.getCurrent = e.prototype.slickCurrentSlide = function() {
      return this.currentSlide
  }
  ,
  e.prototype.getDotCount = function() {
      var i = this
        , e = 0
        , t = 0
        , o = 0;
      if (!0 === i.options.infinite)
          for (; e < i.slideCount; )
              ++o,
              e = t + i.options.slidesToScroll,
              t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      else if (!0 === i.options.centerMode)
          o = i.slideCount;
      else
          for (; e < i.slideCount; )
              ++o,
              e = t + i.options.slidesToScroll,
              t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      return o - 1
  }
  ,
  e.prototype.getLeft = function(i) {
      var e, t, o, s = this, n = 0;
      return s.slideOffset = 0,
      t = s.$slides.first().outerHeight(!0),
      !0 === s.options.infinite ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1,
      n = t * s.options.slidesToShow * -1),
      s.slideCount % s.options.slidesToScroll != 0 && i + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (i > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (i - s.slideCount)) * s.slideWidth * -1,
      n = (s.options.slidesToShow - (i - s.slideCount)) * t * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1,
      n = s.slideCount % s.options.slidesToScroll * t * -1))) : i + s.options.slidesToShow > s.slideCount && (s.slideOffset = (i + s.options.slidesToShow - s.slideCount) * s.slideWidth,
      n = (i + s.options.slidesToShow - s.slideCount) * t),
      s.slideCount <= s.options.slidesToShow && (s.slideOffset = 0,
      n = 0),
      !0 === s.options.centerMode && !0 === s.options.infinite ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : !0 === s.options.centerMode && (s.slideOffset = 0,
      s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)),
      e = !1 === s.options.vertical ? i * s.slideWidth * -1 + s.slideOffset : i * t * -1 + n,
      !0 === s.options.variableWidth && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow),
      e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
      !0 === s.options.centerMode && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow + 1),
      e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0,
      e += (s.$list.width() - o.outerWidth()) / 2)),
      e
  }
  ,
  e.prototype.getOption = e.prototype.slickGetOption = function(i) {
      return this.options[i]
  }
  ,
  e.prototype.getNavigableIndexes = function() {
      var i, e = this, t = 0, o = 0, s = [];
      for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll,
      o = -1 * e.options.slidesToScroll,
      i = 2 * e.slideCount); t < i; )
          s.push(t),
          t = o + e.options.slidesToScroll,
          o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
      return s
  }
  ,
  e.prototype.getSlick = function() {
      return this
  }
  ,
  e.prototype.getSlideCount = function() {
      var e, t, o = this;
      return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0,
      !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(s, n) {
          if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
              return e = n,
              !1
      }),
      Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
  }
  ,
  e.prototype.goTo = e.prototype.slickGoTo = function(i, e) {
      this.changeSlide({
          data: {
              message: "index",
              index: parseInt(i)
          }
      }, e)
  }
  ,
  e.prototype.init = function(e) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"),
      t.buildRows(),
      t.buildOut(),
      t.setProps(),
      t.startLoad(),
      t.loadSlider(),
      t.initializeEvents(),
      t.updateArrows(),
      t.updateDots()),
      e && t.$slider.trigger("init", [t]),
      !0 === t.options.accessibility && t.initADA()
  }
  ,
  e.prototype.initArrowEvents = function() {
      var i = this;
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.on("click.slick", {
          message: "previous"
      }, i.changeSlide),
      i.$nextArrow.on("click.slick", {
          message: "next"
      }, i.changeSlide))
  }
  ,
  e.prototype.initDotEvents = function() {
      var e = this;
      !0 === e.options.dots && e.slideCount > e.options.slidesToShow && i("li", e.$dots).on("click.slick", {
          message: "index"
      }, e.changeSlide),
      !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && !0 === e.options.autoplay && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.setPaused, e, !0)).on("mouseleave.slick", i.proxy(e.setPaused, e, !1))
  }
  ,
  e.prototype.initializeEvents = function() {
      var e = this;
      e.initArrowEvents(),
      e.initDotEvents(),
      e.$list.on("touchstart.slick mousedown.slick", {
          action: "start"
      }, e.swipeHandler),
      e.$list.on("touchmove.slick mousemove.slick", {
          action: "move"
      }, e.swipeHandler),
      e.$list.on("touchend.slick mouseup.slick", {
          action: "end"
      }, e.swipeHandler),
      e.$list.on("touchcancel.slick mouseleave.slick", {
          action: "end"
      }, e.swipeHandler),
      e.$list.on("click.slick", e.clickHandler),
      i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
      e.$list.on("mouseenter.slick", i.proxy(e.setPaused, e, !0)),
      e.$list.on("mouseleave.slick", i.proxy(e.setPaused, e, !1)),
      !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
      !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
      i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)),
      i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)),
      i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
      i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
      i(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
  }
  ,
  e.prototype.initUI = function() {
      var i = this;
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(),
      i.$nextArrow.show()),
      !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show(),
      !0 === i.options.autoplay && i.autoPlay()
  }
  ,
  e.prototype.keyHandler = function(i) {
      var e = this;
      i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
          data: {
              message: "previous"
          }
      }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
          data: {
              message: "next"
          }
      }))
  }
  ,
  e.prototype.lazyLoad = function() {
      var e, t, o = this;
      function s(e) {
          i("img[data-lazy]", e).each(function() {
              var e = i(this)
                , t = i(this).attr("data-lazy")
                , o = document.createElement("img");
              o.onload = function() {
                  e.animate({
                      opacity: 0
                  }, 100, function() {
                      e.attr("src", t).animate({
                          opacity: 1
                      }, 200, function() {
                          e.removeAttr("data-lazy").removeClass("slick-loading")
                      })
                  })
              }
              ,
              o.src = t
          })
      }
      !0 === o.options.centerMode ? !0 === o.options.infinite ? t = (e = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (e = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)),
      t = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (t = (e = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide) + o.options.slidesToShow,
      !0 === o.options.fade && (e > 0 && e--,
      t <= o.slideCount && t++)),
      s(o.$slider.find(".slick-slide").slice(e, t)),
      o.slideCount <= o.options.slidesToShow ? s(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? s(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && s(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow))
  }
  ,
  e.prototype.loadSlider = function() {
      var i = this;
      i.setPosition(),
      i.$slideTrack.css({
          opacity: 1
      }),
      i.$slider.removeClass("slick-loading"),
      i.initUI(),
      "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
  }
  ,
  e.prototype.next = e.prototype.slickNext = function() {
      this.changeSlide({
          data: {
              message: "next"
          }
      })
  }
  ,
  e.prototype.orientationChange = function() {
      this.checkResponsive(),
      this.setPosition()
  }
  ,
  e.prototype.pause = e.prototype.slickPause = function() {
      this.autoPlayClear(),
      this.paused = !0
  }
  ,
  e.prototype.play = e.prototype.slickPlay = function() {
      this.paused = !1,
      this.autoPlay()
  }
  ,
  e.prototype.postSlide = function(i) {
      var e = this;
      e.$slider.trigger("afterChange", [e, i]),
      e.animating = !1,
      e.setPosition(),
      e.swipeLeft = null,
      !0 === e.options.autoplay && !1 === e.paused && e.autoPlay(),
      !0 === e.options.accessibility && e.initADA()
  }
  ,
  e.prototype.prev = e.prototype.slickPrev = function() {
      this.changeSlide({
          data: {
              message: "previous"
          }
      })
  }
  ,
  e.prototype.preventDefault = function(i) {
      i.preventDefault()
  }
  ,
  e.prototype.progressiveLazyLoad = function() {
      var e, t = this;
      i("img[data-lazy]", t.$slider).length > 0 && ((e = i("img[data-lazy]", t.$slider).first()).attr("src", null),
      e.attr("src", e.attr("data-lazy")).removeClass("slick-loading").load(function() {
          e.removeAttr("data-lazy"),
          t.progressiveLazyLoad(),
          !0 === t.options.adaptiveHeight && t.setPosition()
      }).error(function() {
          e.removeAttr("data-lazy"),
          t.progressiveLazyLoad()
      }))
  }
  ,
  e.prototype.refresh = function(e) {
      var t, o, s = this;
      o = s.slideCount - s.options.slidesToShow,
      s.options.infinite || (s.slideCount <= s.options.slidesToShow ? s.currentSlide = 0 : s.currentSlide > o && (s.currentSlide = o)),
      t = s.currentSlide,
      s.destroy(!0),
      i.extend(s, s.initials, {
          currentSlide: t
      }),
      s.init(),
      e || s.changeSlide({
          data: {
              message: "index",
              index: t
          }
      }, !1)
  }
  ,
  e.prototype.registerBreakpoints = function() {
      var e, t, o, s = this, n = s.options.responsive || null;
      if ("array" === i.type(n) && n.length) {
          for (e in s.respondTo = s.options.respondTo || "window",
          n)
              if (o = s.breakpoints.length - 1,
              t = n[e].breakpoint,
              n.hasOwnProperty(e)) {
                  for (; o >= 0; )
                      s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1),
                      o--;
                  s.breakpoints.push(t),
                  s.breakpointSettings[t] = n[e].settings
              }
          s.breakpoints.sort(function(i, e) {
              return s.options.mobileFirst ? i - e : e - i
          })
      }
  }
  ,
  e.prototype.reinit = function() {
      var e = this;
      e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
      e.slideCount = e.$slides.length,
      e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
      e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
      e.registerBreakpoints(),
      e.setProps(),
      e.setupInfinite(),
      e.buildArrows(),
      e.updateArrows(),
      e.initArrowEvents(),
      e.buildDots(),
      e.updateDots(),
      e.initDotEvents(),
      e.checkResponsive(!1, !0),
      !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler),
      e.setSlideClasses(0),
      e.setPosition(),
      e.$slider.trigger("reInit", [e]),
      !0 === e.options.autoplay && e.focusHandler()
  }
  ,
  e.prototype.resize = function() {
      var e = this;
      i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
      e.windowDelay = window.setTimeout(function() {
          e.windowWidth = i(window).width(),
          e.checkResponsive(),
          e.unslicked || e.setPosition()
      }, 50))
  }
  ,
  e.prototype.removeSlide = e.prototype.slickRemove = function(i, e, t) {
      var o = this;
      if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i,
      o.slideCount < 1 || i < 0 || i > o.slideCount - 1)
          return !1;
      o.unload(),
      !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(),
      o.$slides = o.$slideTrack.children(this.options.slide),
      o.$slideTrack.children(this.options.slide).detach(),
      o.$slideTrack.append(o.$slides),
      o.$slidesCache = o.$slides,
      o.reinit()
  }
  ,
  e.prototype.setCSS = function(i) {
      var e, t, o = this, s = {};
      !0 === o.options.rtl && (i = -i),
      e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px",
      t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px",
      s[o.positionProp] = i,
      !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {},
      !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")",
      o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)",
      o.$slideTrack.css(s)))
  }
  ,
  e.prototype.setDimensions = function() {
      var i = this;
      !1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
          padding: "0px " + i.options.centerPadding
      }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow),
      !0 === i.options.centerMode && i.$list.css({
          padding: i.options.centerPadding + " 0px"
      })),
      i.listWidth = i.$list.width(),
      i.listHeight = i.$list.height(),
      !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow),
      i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth),
      i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
      !1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
  }
  ,
  e.prototype.setFade = function() {
      var e, t = this;
      t.$slides.each(function(o, s) {
          e = t.slideWidth * o * -1,
          !0 === t.options.rtl ? i(s).css({
              position: "relative",
              right: e,
              top: 0,
              zIndex: t.options.zIndex - 2,
              opacity: 0
          }) : i(s).css({
              position: "relative",
              left: e,
              top: 0,
              zIndex: t.options.zIndex - 2,
              opacity: 0
          })
      }),
      t.$slides.eq(t.currentSlide).css({
          zIndex: t.options.zIndex - 1,
          opacity: 1
      })
  }
  ,
  e.prototype.setHeight = function() {
      var i = this;
      if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
          var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
          i.$list.css("height", e)
      }
  }
  ,
  e.prototype.setOption = e.prototype.slickSetOption = function(e, t, o) {
      var s, n, l = this;
      if ("responsive" === e && "array" === i.type(t))
          for (n in t)
              if ("array" !== i.type(l.options.responsive))
                  l.options.responsive = [t[n]];
              else {
                  for (s = l.options.responsive.length - 1; s >= 0; )
                      l.options.responsive[s].breakpoint === t[n].breakpoint && l.options.responsive.splice(s, 1),
                      s--;
                  l.options.responsive.push(t[n])
              }
      else
          l.options[e] = t;
      !0 === o && (l.unload(),
      l.reinit())
  }
  ,
  e.prototype.setPosition = function() {
      var i = this;
      i.setDimensions(),
      i.setHeight(),
      !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(),
      i.$slider.trigger("setPosition", [i])
  }
  ,
  e.prototype.setProps = function() {
      var i = this
        , e = document.body.style;
      i.positionProp = !0 === i.options.vertical ? "top" : "left",
      "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"),
      void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0),
      i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex),
      void 0 !== e.OTransform && (i.animType = "OTransform",
      i.transformType = "-o-transform",
      i.transitionType = "OTransition",
      void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
      void 0 !== e.MozTransform && (i.animType = "MozTransform",
      i.transformType = "-moz-transform",
      i.transitionType = "MozTransition",
      void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)),
      void 0 !== e.webkitTransform && (i.animType = "webkitTransform",
      i.transformType = "-webkit-transform",
      i.transitionType = "webkitTransition",
      void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)),
      void 0 !== e.msTransform && (i.animType = "msTransform",
      i.transformType = "-ms-transform",
      i.transitionType = "msTransition",
      void 0 === e.msTransform && (i.animType = !1)),
      void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform",
      i.transformType = "transform",
      i.transitionType = "transition"),
      i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
  }
  ,
  e.prototype.setSlideClasses = function(i) {
      var e, t, o, s, n = this;
      t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
      n.$slides.eq(i).addClass("slick-current"),
      !0 === n.options.centerMode ? (e = Math.floor(n.options.slidesToShow / 2),
      !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i,
      t.slice(o - e + 1, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")),
      0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")),
      n.$slides.eq(i).addClass("slick-center")) : i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow,
      o = !0 === n.options.infinite ? n.options.slidesToShow + i : i,
      n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
      "ondemand" === n.options.lazyLoad && n.lazyLoad()
  }
  ,
  e.prototype.setupInfinite = function() {
      var e, t, o, s = this;
      if (!0 === s.options.fade && (s.options.centerMode = !1),
      !0 === s.options.infinite && !1 === s.options.fade && (t = null,
      s.slideCount > s.options.slidesToShow)) {
          for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow,
          e = s.slideCount; e > s.slideCount - o; e -= 1)
              t = e - 1,
              i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
          for (e = 0; e < o; e += 1)
              t = e,
              i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
          s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
              i(this).attr("id", "")
          })
      }
  }
  ,
  e.prototype.setPaused = function(i) {
      var e = this;
      !0 === e.options.autoplay && !0 === e.options.pauseOnHover && (e.paused = i,
      i ? e.autoPlayClear() : e.autoPlay())
  }
  ,
  e.prototype.selectHandler = function(e) {
      var t = this
        , o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide")
        , s = parseInt(o.attr("data-slick-index"));
      if (s || (s = 0),
      t.slideCount <= t.options.slidesToShow)
          return t.setSlideClasses(s),
          void t.asNavFor(s);
      t.slideHandler(s)
  }
  ,
  e.prototype.slideHandler = function(i, e, t) {
      var o, s, n, l, r, a = this;
      if (e = e || !1,
      (!0 !== a.animating || !0 !== a.options.waitForAnimate) && !(!0 === a.options.fade && a.currentSlide === i || a.slideCount <= a.options.slidesToShow))
          if (!1 === e && a.asNavFor(i),
          o = i,
          r = a.getLeft(o),
          l = a.getLeft(a.currentSlide),
          a.currentLeft = null === a.swipeLeft ? l : a.swipeLeft,
          !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll))
              !1 === a.options.fade && (o = a.currentSlide,
              !0 !== t ? a.animateSlide(l, function() {
                  a.postSlide(o)
              }) : a.postSlide(o));
          else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll))
              !1 === a.options.fade && (o = a.currentSlide,
              !0 !== t ? a.animateSlide(l, function() {
                  a.postSlide(o)
              }) : a.postSlide(o));
          else {
              if (!0 === a.options.autoplay && clearInterval(a.autoPlayTimer),
              s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o,
              a.animating = !0,
              a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
              n = a.currentSlide,
              a.currentSlide = s,
              a.setSlideClasses(a.currentSlide),
              a.updateDots(),
              a.updateArrows(),
              !0 === a.options.fade)
                  return !0 !== t ? (a.fadeSlideOut(n),
                  a.fadeSlide(s, function() {
                      a.postSlide(s)
                  })) : a.postSlide(s),
                  void a.animateHeight();
              !0 !== t ? a.animateSlide(r, function() {
                  a.postSlide(s)
              }) : a.postSlide(s)
          }
  }
  ,
  e.prototype.startLoad = function() {
      var i = this;
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(),
      i.$nextArrow.hide()),
      !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(),
      i.$slider.addClass("slick-loading")
  }
  ,
  e.prototype.swipeDirection = function() {
      var i, e, t, o, s = this;
      return i = s.touchObject.startX - s.touchObject.curX,
      e = s.touchObject.startY - s.touchObject.curY,
      t = Math.atan2(e, i),
      (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
      o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "left" : "right" : "vertical"
  }
  ,
  e.prototype.swipeEnd = function(i) {
      var e, t = this;
      if (t.dragging = !1,
      t.shouldClick = !(t.touchObject.swipeLength > 10),
      void 0 === t.touchObject.curX)
          return !1;
      if (!0 === t.touchObject.edgeHit && t.$slider.trigger("edge", [t, t.swipeDirection()]),
      t.touchObject.swipeLength >= t.touchObject.minSwipe)
          switch (t.swipeDirection()) {
          case "left":
              e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide + t.getSlideCount()) : t.currentSlide + t.getSlideCount(),
              t.slideHandler(e),
              t.currentDirection = 0,
              t.touchObject = {},
              t.$slider.trigger("swipe", [t, "left"]);
              break;
          case "right":
              e = t.options.swipeToSlide ? t.checkNavigable(t.currentSlide - t.getSlideCount()) : t.currentSlide - t.getSlideCount(),
              t.slideHandler(e),
              t.currentDirection = 1,
              t.touchObject = {},
              t.$slider.trigger("swipe", [t, "right"])
          }
      else
          t.touchObject.startX !== t.touchObject.curX && (t.slideHandler(t.currentSlide),
          t.touchObject = {})
  }
  ,
  e.prototype.swipeHandler = function(i) {
      var e = this;
      if (!(!1 === e.options.swipe || "ontouchend"in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse")))
          switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1,
          e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold,
          !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action) {
          case "start":
              e.swipeStart(i);
              break;
          case "move":
              e.swipeMove(i);
              break;
          case "end":
              e.swipeEnd(i)
          }
  }
  ,
  e.prototype.swipeMove = function(i) {
      var e, t, o, s, n, l = this;
      return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null,
      !(!l.dragging || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide),
      l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX,
      l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY,
      l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))),
      !0 === l.options.verticalSwiping && (l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2)))),
      "vertical" !== (t = l.swipeDirection()) ? (void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && i.preventDefault(),
      s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1),
      !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
      o = l.touchObject.swipeLength,
      l.touchObject.edgeHit = !1,
      !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction,
      l.touchObject.edgeHit = !0),
      !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s,
      !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s),
      !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null,
      !1) : void l.setCSS(l.swipeLeft))) : void 0)
  }
  ,
  e.prototype.swipeStart = function(i) {
      var e, t = this;
      if (1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow)
          return t.touchObject = {},
          !1;
      void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]),
      t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX,
      t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY,
      t.dragging = !0
  }
  ,
  e.prototype.unfilterSlides = e.prototype.slickUnfilter = function() {
      var i = this;
      null !== i.$slidesCache && (i.unload(),
      i.$slideTrack.children(this.options.slide).detach(),
      i.$slidesCache.appendTo(i.$slideTrack),
      i.reinit())
  }
  ,
  e.prototype.unload = function() {
      var e = this;
      i(".slick-cloned", e.$slider).remove(),
      e.$dots && e.$dots.remove(),
      e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
      e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
      e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
  }
  ,
  e.prototype.unslick = function(i) {
      var e = this;
      e.$slider.trigger("unslick", [e, i]),
      e.destroy()
  }
  ,
  e.prototype.updateArrows = function() {
      var i = this;
      Math.floor(i.options.slidesToShow / 2),
      !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
      i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
      0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
      i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
      i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
      i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
  }
  ,
  e.prototype.updateDots = function() {
      var i = this;
      null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
      i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
  }
  ,
  e.prototype.visibility = function() {
      var i = this;
      document[i.hidden] ? (i.paused = !0,
      i.autoPlayClear()) : !0 === i.options.autoplay && (i.paused = !1,
      i.autoPlay())
  }
  ,
  e.prototype.initADA = function() {
      var e = this;
      e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
          "aria-hidden": "true",
          tabindex: "-1"
      }).find("a, input, button, select").attr({
          tabindex: "-1"
      }),
      e.$slideTrack.attr("role", "listbox"),
      e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t) {
          i(this).attr({
              role: "option",
              "aria-describedby": "slick-slide" + e.instanceUid + t
          })
      }),
      null !== e.$dots && e.$dots.attr("role", "tablist").find("li").each(function(t) {
          i(this).attr({
              role: "presentation",
              "aria-selected": "false",
              "aria-controls": "navigation" + e.instanceUid + t,
              id: "slick-slide" + e.instanceUid + t
          })
      }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
      e.activateADA()
  }
  ,
  e.prototype.activateADA = function() {
      this.$slideTrack.find(".slick-active").attr({
          "aria-hidden": "false"
      }).find("a, input, button, select").attr({
          tabindex: "0"
      })
  }
  ,
  e.prototype.focusHandler = function() {
      var e = this;
      e.$slider.on("focus.slick blur.slick", "*", function(t) {
          t.stopImmediatePropagation();
          var o = i(this);
          setTimeout(function() {
              e.isPlay && (o.is(":focus") ? (e.autoPlayClear(),
              e.paused = !0) : (e.paused = !1,
              e.autoPlay()))
          }, 0)
      })
  }
  ,
  i.fn.slick = function() {
      var i, t, o = this, s = arguments[0], n = Array.prototype.slice.call(arguments, 1), l = o.length;
      for (i = 0; i < l; i++)
          if ("object" == typeof s || void 0 === s ? o[i].slick = new e(o[i],s) : t = o[i].slick[s].apply(o[i].slick, n),
          void 0 !== t)
              return t;
      return o
  }
});
